<template>
  <attribute-form
    :initAttribute="initAttribute"
    :successMsg="t('attributeCreated')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AttributeForm from '@/views/inventory/attributes/AttributeForm.vue'

import Attribute from '@/models/inventory/Attribute'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-attribute',
  components: {
    AttributeForm
  },
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          attributeCreated: 'Attribute was created successfully'
        },
        ar: {
          attributeCreated: 'تم انشاء نوع الصنف بنجاح'
        }
      }
    })

    return { t }
  },
  data() {
    return {
      initAttribute: new Attribute()
    }
  },

  methods: {
    async submit(attribute: Attribute) {
      try {
        await this.$http.post(Attribute.ENDPOINT, attribute)
        await this.$router.push(this.$Route.INVENTORY_ATTRIBUTES)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
